import { useVesselCreateModal } from '../../common/hooks/useVesselCreateModal';
import { Button } from '../../cdl/Button/Button';
import { translate } from '../../common/helpers/translate.helper';
import { IconPlus } from '../../common/icons/cdl/Plus';

export const CreateVesselButton = () => {
    const { open } = useVesselCreateModal();

    return (
        <Button emphasis="high" LeadingIcon={IconPlus} onClick={open}>
            {translate('vessel.create')}
        </Button>
    );
};
